import { CloudActions } from 'reactApp/constants/cloudActions';

import { APICallV2Post } from './APICall';

export class TrashbinRestoreApiCall extends APICallV2Post {
    _method = 'trashbin/restore';
    _headers = { 'X-VFS-Action': CloudActions.RESTORE };
}
